export default __webpack_public_path__ + "static/media/right-bubble.a03513d2.png";